export default "__VITE_ASSET__ClZHpGj3__"